import { useNavigate } from "react-router-dom";
import { SessionService } from "../../services/persistService";
import { ROUTES } from "../../routes";

const HomePage = () => {
  const lastRestaurantId = SessionService.getItem("restaurantId");

  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 p-4 bg-primary-500">
      <img
        src="/buddybox-logo-dark.svg"
        className="w-56"
        alt="Logo da Buddybox"
      />

      <p className="text-white text-xl max-w-md text-center">
        Acesse o cardápio do restaurante por um link ou QR code e faça seu
        pedido de forma rápida e fácil!
      </p>

      {lastRestaurantId && (
        <button
          onClick={() => navigate(ROUTES.RESTAURANT(lastRestaurantId))}
          className="px-6 py-3 bg-white text-primary-500 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
        >
          Último restaurante acessado
        </button>
      )}
    </div>
  );
};

export default HomePage;
